<script>
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import ButtonGroup from "@/components/molecules/button-group";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";
import panierUtils from "@/utils/panier";

export default {
  props: {
    typePanier: {
      type: String,
      required: false,
      default: "drive"
    }
  },
  emits: ["validate"],
  setup() {
    const { trackEvent } = useInteractionDoneTracking();
    return { trackEvent };
  },
  name: "PopinViderPanier",
  components: { Popin, Button, Icon, ButtonGroup, Badge },
  methods: {
    validate() {
      this.$refs.popin.hide();
      this.$emit("validate");
      this.trackEvent({
        actionGA: trackingCodes.ACTIONGA.delete,
        categoryGA: trackingCodes.ACTIONGA.cart,
        labelGA: ""
      });
    },
    show() {
      this.$refs.popin.show();
    }
  },
  computed: {
    typePanierLabel() {
      return panierUtils.getLabelByTypePanier(this.typePanier);
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    aria-label="Vider le panier"
    size="sm"
  >
    <div class="u-text-center">
      <Badge
        variant="primary"
        class="u-mb-sm"
        circle
        size="xlg"
      >
        <Icon
          name="alert"
          variant="white"
          size="xlg"
        />
      </Badge>
      <h1 class="u-font-secondary u-color-primary u-font-24 u-font-700">
        Êtes-vous sûr(e) de vouloir vider votre panier {{ typePanier ? typePanierLabel + ' ' : '' }} ?
      </h1>
      <ButtonGroup class="u-mt-md">
        <Button
          outline
          variant="primary"
          size="md"
          radius="full"
          @click="$refs.popin.hide()"
        >
          Annuler
        </Button>
        <Button
          variant="secondary"
          size="md"
          radius="full"
          @click="validate()"
        >
          Je valide
        </Button>
      </ButtonGroup>
    </div>
  </Popin>
</template>
